import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { injectCountryList } from '@core/country-data';
import type { Country } from '@core/locations-types';
import type { SelectOption } from '@core/user-interface-legacy';
import { SelectComponent } from '@core/user-interface-legacy';

import { Destroyable } from '../../../common';
import type { DynamicCountrySelectInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class CountrySelectInput extends DynamicFormInput<DynamicCountrySelectInputConfig> {}

@Component({
  selector: 'rti-country-select-input',
  templateUrl: './country-select-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectComponent],
})
@Destroyable()
export class CountrySelectInputComponent {
  public readonly input = input<CountrySelectInput>(undefined!);

  public countryOptions: Array<SelectOption<string>> = injectCountryList().map(
    (country: Country) => ({ label: country.name, value: country.code }),
  );
}
